/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PaginationParams, toHttpParams } from '../model/api/pagination-params';
import { environment } from 'src/environments/environment';
import {
    DataRest, EventTypesData, IdDataRest, MailNotificationConfigsData,
    ManeuverNotificationConfigsData, PaginatedEventMessages
} from '../model/api/data-rest';
import { resources } from './api';
import { EventFilterParams, filterParamToString } from '../model/api/filter-params';
import { ManeuverNotificationConfig } from '../model/maneuver-notification-config';

@Injectable({
    providedIn: 'root'
})
export class EventService {

    constructor(
        private http: HttpClient,
    ) { }

    getEvents(
        language?: string,
        paging?: PaginationParams,
        filter?: EventFilterParams,
        userId?: number
    ): Observable<PaginatedEventMessages> {
        let params: HttpParams = new HttpParams();
        if (paging) {
            params = toHttpParams(paging);
        }
        const filterOptions = Object.getOwnPropertyNames(filter);
        for (const filterOption of filterOptions) {
            if (typeof filter[filterOption] === 'undefined') {
                continue;
            }
            params = params.set(filterOption, filterParamToString(filter, filterOption));
        }
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        if (language) {
            params = params.set('language', language);
        }
        return this.http.get<PaginatedEventMessages>(`${environment.apiUrl}${resources.get('event')}`, { params });
    }

    getEventTypes(): Observable<EventTypesData> {
        return this.http.get<EventTypesData>(`${environment.apiUrl}${resources.get('event')}${resources.get('types')}`);
    }

    getEmailDeviceConfig(userId?: number): Observable<MailNotificationConfigsData> {
        let params = new HttpParams();
        if (userId) {//TODO VERIFICARE era !!userId
            params = params.set('userId', userId.toString());
        }
        return this.http.get<MailNotificationConfigsData>(`${environment.apiUrl}${resources.get('event')}${resources.get('mailDevNotif')}`, { params });
    }

    saveEmailDeviceConfig(deviceId: number, notifyLevel: number, userId?: number): Observable<DataRest> {
        let params = new HttpParams();
        if (userId) {//TODO VERIFICARE era !!userId
            params = params.set('userId', userId.toString());
        }
        const config = {
            DeviceId: deviceId,
            NotifyLevel: notifyLevel
        };
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('event')}${resources.get('mailDevNotif')}`, config, { params });
    }

    deleteEmailConfig(configId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('event')}${resources.get('mailDevNotif')}/${configId}`);
    }

    getManeuversConfig(deviceId: number): Observable<ManeuverNotificationConfigsData> {
        return this.http.get<ManeuverNotificationConfigsData>(
            `${environment.apiUrl}${resources.get('event')}${resources.get('maneuversNotifyRulesByDevice')}/${deviceId}`
        );
    }

    createManeuversConfig(config: ManeuverNotificationConfig): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('event')}${resources.get('maneuversNotifyRules')}`, config);
    }

    updateManeuversConfig(config: ManeuverNotificationConfig): Observable<DataRest> {
        return this.http.put<IdDataRest>(`${environment.apiUrl}${resources.get('event')}${resources.get('maneuversNotifyRules')}/${config.Id}`, config);
    }

    deleteManeuversConfig(configId) {
        return this.http.delete<IdDataRest>(`${environment.apiUrl}${resources.get('event')}${resources.get('maneuversNotifyRules')}/${configId}`);
    }
}
